import { RouteNamesEnum } from '@/enums/RouteNamesEnum';

const OrdersRoutes = [
    {
        path: '/orders',
        component: () => import('../components/general/RootModule.vue'),
        meta: {
            title: 'OrdersModule.module-name',
            icon: 'mdi-cart-outline',
            auth: {
                required: true,
            },
            showInMenu: true,
            moduleRoot: true,
        },
        children: [
            {
                path: '',
                name: RouteNamesEnum.Orders,
                component: () => import('../views/orders-module/OrdersView.vue'),
                meta: {
                    title: 'OrdersModule.orders',
                    auth: {
                        required: true,
                    },
                    showInMenu: true,
                    isArchive: false,
                },
            },
            {
                path: 'chat',
                redirect: '/orders',
            },
            {
                path: 'chat/:id(\\d+)',
                name: RouteNamesEnum.Chat,
                component: () => import('../views/orders-module/ChatView.vue'),
                meta: {
                    title: 'ChatModule.chat',
                    auth: {
                        required: true,
                    },
                    showInMenu: false,
                    isArchive: false,
                },
            },
        ],
    },
];

export default OrdersRoutes;
